import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { server } from "../server";

export const fetchStudents = createAsyncThunk(
  "students/fetchStudents",
  async (_, { rejectWithValue }) => {
    try {
      const allStudents = [];
      const limit = 500;
      let page = 1;
      let hasMore = true;

      while (hasMore) {
        const response = await axios.get(
          `${server}/getAllStudentsDataFromMongodb?page=${page}&limit=${limit}`,
          {
            headers: {
              Authorization: `${localStorage.getItem("token")}`,
            },
          }
        );

        const parsed = response?.data;
        if (!parsed || !parsed.data) {
          return rejectWithValue("Missing data");
        }

        allStudents.push(...parsed.data);
        hasMore = parsed.pagination?.hasNextPage;
        page++;
      }

      return allStudents;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const studentSlice = createSlice({
  name: "students",
  initialState: {
    studentDetails: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStudents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStudents.fulfilled, (state, action) => {
        state.loading = false;
        state.studentDetails = action.payload;
      })
      .addCase(fetchStudents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default studentSlice.reducer;
